import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExportMetricsDialogComponent } from '@app/modules/metrics/export-metrics-dialog/export-metrics-dialog.component';
import { ExportsComponent } from '@app/modules/metrics/exports/exports.component';
import { ListViewDialogComponent } from '@app/modules/metrics/list-view-dialog/list-view-dialog.component';
import { MetricsComponent } from '@app/modules/metrics/metrics.component';
import { ReservationsComponent } from '@app/modules/metrics/reservations/reservations.component';
import { ReviewsComponent } from '@app/modules/metrics/reviews/reviews.component';
import { SaveViewDialogComponent } from '@app/modules/metrics/save-view-dialog/save-view-dialog.component';
import { SaveViewComponent } from '@app/modules/metrics/save-view/save-view.component';
import { TasksComponent } from '@app/modules/metrics/tasks/tasks.component';
import { TaxesComponent } from '@app/modules/metrics/taxes/taxes.component';
import { MetricsStateModule } from '@app/shared/+state/metrics';
import { SharedModule } from '@app/shared/shared.module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { ClipboardModule } from 'ngx-clipboard';
import { MetricsRoutingModule } from './metrics-routing.module';
/**
 * we removed pipes module, we need to see which pipes are used in the metrics
 *
 */

@NgModule({
  declarations: [
    MetricsComponent,
    ReservationsComponent,
    TasksComponent,
    ReviewsComponent,
    TaxesComponent,
    ExportsComponent,
    ExportMetricsDialogComponent,
    SaveViewDialogComponent,
    ListViewDialogComponent,
    SaveViewComponent,
  ],
  imports: [SatPopoverModule, ClipboardModule, CommonModule, MetricsRoutingModule, SharedModule, MetricsStateModule],
  providers: [],
})
export class MetricsModule {}
